import { defineComponent as _defineComponent } from 'vue'
import ToggleButton from "@/components/ui/ToggleButton.vue";
  import { HouseInclusionsPack } from "@/types/HouseInclusionPack";
  import { formatPrice } from "@/helpers/transformation/price";
  import { useIsDesktop } from "@/features/useIsDesktop";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'InclusionPackCard',
  props: {
    pack: {},
    isSelected: { type: Boolean },
    expandedSections: {},
    hasSelected: { type: Boolean }
  },
  emits: ["onSelect", "onToggleSection"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const { isDesktop } = useIsDesktop(990);

  const toggleSection = (sectionKey: string) =>
    emits("onToggleSection", sectionKey);

  const onHeaderClick = (event: MouseEvent) => {
    if ((event.target as HTMLElement).closest(".toggle-button")) return;

    emits("onSelect", props.pack);
  };

const __returned__ = { props, emits, isDesktop, toggleSection, onHeaderClick, ToggleButton, get HouseInclusionsPack() { return HouseInclusionsPack }, get formatPrice() { return formatPrice }, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})